
        import { Translator } from './src/i18n/index.ts';

        Translator.updatePageTitle('pps_common:redirect.appName');
        Translator.updateElements();

        console.log(Translator.translate);

        // 自動重定向到主頁
        window.location.href = './pages/mpm/index.html';
    